window.addEventListener('DOMContentLoaded', (event) => {


     // get input .search-field
        const searchField = document.querySelector('.search-field');
        if( !searchField ) return;
        // get .search__clear-btn
        let searchClearBtn = document.querySelector('.search__clear-btn');
        // get .search-submit
        let searchSubmit = document.querySelector('.search-submit');

        // add event listener to searchField
        searchField.addEventListener('input', () => {
            if (searchField.value.length > 0) {
                searchClearBtn.style.display = 'block';
                searchSubmit.style.display = 'none';
            } else {
                searchClearBtn.style.display = 'none';
                searchSubmit.style.display = 'block';
            }
        });

        // add event listener to searchClearBtn
        searchClearBtn.addEventListener('click', () => {
            searchField.value = '';
            searchClearBtn.style.display = 'none';
            searchSubmit.style.display = 'block';
        });



});